// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8620929a","455":"be20cfd9"}[chunkId] + ".chunk.js";
};